import { getSessionInfo } from '@northern.tech/store/auth';

export class SecretsError extends Error {
  constructor(
    public status: number,
    public code: string
  ) {
    super(code);
  }
}

// Avoid the shared diagnostic client: its error objects may include request YAML.
export async function secretsRequest(path: string, method = 'GET', body?: object, revision?: string, signal?: AbortSignal) {
  const { token } = getSessionInfo();
  if (!token) throw new SecretsError(401, 'authentication_required');
  const response = await fetch(`/api/management/v1/z2play/secrets${path}`, {
    method,
    credentials: 'omit',
    cache: 'no-store',
    redirect: 'error',
    signal,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...(revision ? { 'If-Match': `"${revision}"` } : {})
    },
    ...(body ? { body: JSON.stringify(body) } : {})
  });
  if (!response.ok) {
    // Never propagate server bodies or request objects into error reporting.
    throw new SecretsError(response.status, response.status === 409 ? 'conflict' : 'request_failed');
  }
  return response.json();
}
